import type {SvelteComponentConstructor} from '../../../svelte/types';
import type {ValueEditorRegistrationService} from '../editor-type-registration/value-editor-registration.service';
import type {ValueEditorAliasesService} from '../aliases/value-editor-aliases.service';
import type {ValueEditorType, ValueEditorTypeOrAlias} from '../types';

export class ValueEditorTypeResolutionService {
    public static serviceName = 'valueEditorTypeResolutionService';

    /*@ngInject*/
    constructor(private valueEditorRegistrationService: ValueEditorRegistrationService,
                private valueEditorAliasesService: ValueEditorAliasesService) {
    }

    public resolveRealType(typeOrAlias: ValueEditorTypeOrAlias): ValueEditorType {
        if (this.valueEditorAliasesService.isAlias(typeOrAlias)) {
            return this.valueEditorAliasesService.getAlias(typeOrAlias);
        }
        return typeOrAlias;
    }

    public getEditorComponentByTypeOrAlias(typeOrAlias: ValueEditorTypeOrAlias): SvelteComponentConstructor<any> {
        const type = this.resolveRealType(typeOrAlias)
        return this.valueEditorRegistrationService.getEditorComponentForType(type);
    }
}